import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import InputError from './InputError';
import moment from 'moment';
import GA from '../lib/GoogleAnalyticsWrapper'
import 'react-datepicker/dist/react-datepicker.css';

// limit date range for freemium
export const EARLIEST_DATE = moment("20020101", "YYYYMMDD");
export const LAST_DATE = moment("20170501", "YYYYMMDD");

class PeriodSelector extends Component {
	constructor(props) {
    super(props);

    this.state = {
      period: {
        startDate: EARLIEST_DATE,
        endDate: LAST_DATE
      },
      valid: true,
		};

    this.handleChangeStart = this.handleChangeStart.bind(this);
    this.handleChangeEnd = this.handleChangeEnd.bind(this);
  }

  handleChangeStart(startDate) { this.dataUpdate(startDate, this.state.period.endDate) }
  handleChangeEnd(endDate) { this.dataUpdate(this.state.period.startDate, endDate) }

	dataUpdate(startDate, endDate) {
    var period = {startDate, endDate};
    var name = this.props.name;
    var validationResult = this.validate(period);
    this.setState({period});
		this.setState(validationResult);
    this.props.dataUpdate({name, value: period, valid : validationResult.valid});
		GA.pageview("period-selector");
	}

	validate(period) {
		var startDate = Date.parse(period.startDate);
    if (startDate < EARLIEST_DATE) {
			return {valid : false, errorMessage : "We are still expanding our capabilities to handle dates earlier than " + EARLIEST_DATE.format("MM/DD/YYYY")};
		}
		var endDate = Date.parse(period.endDate);
		if (endDate > LAST_DATE) {
			return {valid : false, errorMessage : "We are still expanding our capabilities to handle dates after " + LAST_DATE.format("MM/DD/YYYY")};
		}
    if (endDate > moment()) {
			return {valid : false, errorMessage : "End date can not be later than today"};
		}
    if (startDate >= endDate) {
			return {valid : false, errorMessage : "Start date must be before end date"};
		}
		return {valid : true};
	}

	render() {
		var style = {flexDirection: 'row', fontSize:16};
		return (
			<div>
				<div className="time-period" style={style}>
          <DatePicker
              selected={this.state.period.startDate}
              placeholderText="Start Date"
              selectsStart
              showYearDropdown
              dateFormatCalendar="MMMM"
              scrollableYearDropdown
              onChange={this.handleChangeStart}
          />
          <DatePicker
              selected={this.state.period.endDate}
              placeholderText="End Date"
              selectsEnd
              showYearDropdown
              dateFormatCalendar="MMMM"
              scrollableYearDropdown
              onChange={this.handleChangeEnd}
          />
        </div>

				<InputError
					visible={!this.state.valid}
					errorMessage={this.state.errorMessage} />
			</div>
		);
	}
}

export default PeriodSelector;



// WEBPACK FOOTER //
// ./src/components/PeriodSelector.js